module.exports = __webpack_public_path__ + "img/list_efaas.1a3d9a87.jpg";